import React, { useState } from "react";
import './style.css';
import { Link } from "react-router-dom";
import Button from "../CtaButton";

const WhyChooseBitsclan = ({
    heading,
    shortHeading,
    subheading,
    tabs,
    bgClassHere,
    btnText2,
    ctaText,
    expandAllAccordions = false
}) => {

    const [activeTab, setActiveTab] = useState("Tab1");

    const handleToggle = (id) => {
        // If the clicked tab is already open, close it, otherwise open it
        setActiveTab(activeTab === id ? null : id);
    };

    // Determine if an accordion item should be initially expanded
    const isItemExpanded = (index) => {
        if (expandAllAccordions) {
            return true; // All items expanded when prop is true
        }
        return index === 0; // Only first item expanded by default
    };

    return (
        <>
            <div className="why-choose-bitsclan-main">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="sticy-left-side-section">
                                <div className="why-top-content">
                                    <h3 className="low-top-heading">{shortHeading || "Custom development services"}</h3>
                                    <h2 dangerouslySetInnerHTML={{ __html: heading }}></h2>
                                    <p className="mb-4" dangerouslySetInnerHTML={{ __html: subheading }}></p>
                                </div>
                                <Button text={ctaText || "Connect with the clan"} link="/contact-us" />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="why-choose-bitsclan-new-section-accordian">

                                <div className="accordion accordion-flush" id="why-us-accordian">
                                    {tabs?.map((tab, index) => (
                                        <div key={tab.id} className="accordion-item why-choose-bitsclan-new-section-accordian-item">
                                            <h2 className="accordion-header" id={`heading${tab.id}`}>
                                                <button
                                                    className={`accordion-button why-choose-bitsclan-new-section-accordian-button-text ${!isItemExpanded(index) ? 'collapsed' : ''}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#flush-collapse${tab.id}`}
                                                    aria-expanded={isItemExpanded(index) ? 'true' : 'false'}
                                                    aria-controls={`flush-collapse${tab.id}`}
                                                >
                                                    {tab.label}
                                                </button>
                                            </h2>
                                            <div
                                                id={`flush-collapse${tab.id}`}
                                                className={`accordion-collapse collapse ${isItemExpanded(index) ? 'show' : ''}`}
                                                {...(!expandAllAccordions && { 'data-bs-parent': '#why-us-accordian' })}
                                            >
                                                <div className="accordion-body">
                                                    <div className="why-choose-bitsclan-new-section-accordian-text-box">
                                                        <p className="description-text-white">{tab.content}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* <div className="accordion" id="accordionFlushExample">
                                    {tabs.map((tab) => (
                                        <div key={tab.id} className="accordion-item">
                                            <div
                                                className={`accordion-header ${activeTab === tab.id ? "active" : ""}`}
                                                onClick={() => toggleTab(tab.id)}
                                            >
                                                <h5 className="mb-0">{tab.label}</h5>
                                            </div>
                                            {activeTab === tab.id && (
                                                <div className="accordion-body">
                                                    <p className="description-text-white">{tab.content}</p>
                                                    <p className="description-text-white">{tab.content2}</p>
                                                    <ul>
                                                        {tab.featureList?.map((list, index) => (
                                                            <li key={index}>{list.text}</li>
                                                        ))}
                                                    </ul>
                                                    {tab.btnText && (
                                                        <div className="hire-us-cta-btn">
                                                            <a href="/contact-us" className="btn-left-space">
                                                                {tab.btnText}
                                                            </a>
                                                        </div>
                                                    )}
                                                    {tab.btnText2 && (
                                                        <div className="hire-us-cta-btn d-flex ms-4 mt-3">
                                                            <a href="https://calendly.com/bitsclan-it/30min?month=2025-01" target="_blank">
                                                                {tab.btnText2}
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div> */}
                            </div>
                        </div>
                    </div>

                    {/* <div className="row why-tab-content-box">
                        <div className="tab-menu border-right-box col-md-4">
                            {tabs.map((tab) => (
                                <div
                                    key={tab.id}
                                    className={`tab-item ${activeTab === tab.id ? "active" : ""} d-flex flex-row gap-2 align-items-center`}
                                    onClick={() => setActiveTab(tab.id)}
                                >
                                    <p className="m-0">{tab.label}</p>
                                </div>
                            ))}
                        </div>
                        <div className="tab-content col-md-8 who-we-are-page-content">
                            <div className={` ${bgClassHere || null}`}>
                                <h4 className="sub-heading-industries">{tabs.find((tab) => tab.id === activeTab)?.label}</h4>
                                <p>{tabs.find((tab) => tab.id === activeTab)?.content}</p>
                                <p>{tabs.find((tab) => tab.id === activeTab)?.content2}</p>

                                <ul>
                                    {tabs.find((tab) => tab.id === activeTab)?.featureList?.map((list, index) => (
                                        <li key={index}>{list?.text}</li>
                                    ))}
                                </ul>

                                <div className="hire-us-cta-btn">
                                    {tabs.find((tab) => tab.id === activeTab)?.btnText && <Link className="btn-left-space" to={"/contact-us"}>{tabs.find((tab) => tab.id === activeTab)?.btnText}</Link>}
                                </div>

                                <div className="hire-us-cta-btn d-flex ms-4 mt-3">
                                    {btnText2 && <a href="https://calendly.com/bitsclan-it/30min?month=2025-01" target="_blank">{btnText2}</a>}
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    )
}

export default WhyChooseBitsclan
